module.exports = __webpack_public_path__ + "static/media/MOGUL-BNB-APE.05d62b94.png";